// ABOUTME: Hook to read custom pages configuration from SettingsContext.
// ABOUTME: Filters pages by requiredRole using the auth context.

import { CustomPage } from '@src/__generated__/types';
import { useAuth } from '@src/hooks';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext, useMemo } from 'react';

/**
 * Reads custom pages from settings and filters by user roles.
 * Returns an empty array if no custom pages are configured.
 */
export function useCustomPages(): CustomPage[] {
    const settings = useContext(SettingsContext);
    const { hasUserRole } = useAuth();

    return useMemo(() => {
        const pages = settings?.customPages;
        if (!pages) return [];

        const ordersEnabled = !!settings?.cpq?.enableOrders;
        const ordersHierarchyId = settings?.cpq?.hierarchies?.orders;

        return pages.filter(page => {
            // An `orders` page is only shown while order management is enabled, and never the
            // seeded one on the orders hierarchy: the orders have native pages (/orders).
            if (page.id === 'orders' && (!ordersEnabled || page.hierarchyId === ordersHierarchyId))
                return false;
            if (!page.requiredRole) return true;
            return hasUserRole(page.requiredRole);
        });
    }, [settings, hasUserRole]);
}
